(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artist-work-player"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-artist-work-player]';

    const initialize = (root) => {
      if (!root || root.dataset.awpInitialized === 'true') return;
      root.dataset.awpInitialized = 'true';

      const dataNode = root.querySelector('[data-awp-data]');
      const mediaShell = root.querySelector('[data-awp-media-shell]');
      const image = root.querySelector('[data-awp-image]');
      const video = root.querySelector('[data-awp-video]');
      const videoBadge = root.querySelector('[data-awp-video-badge]');
      const productGrid = root.querySelector('[data-awp-product-grid]');
      const productCards = Array.from(root.querySelectorAll('[data-awp-product-card]')).map((card) => ({
        card,
        image: card.querySelector('[data-awp-product-card-image]'),
        title: card.querySelector('[data-awp-product-card-title]'),
        placement: card.querySelector('[data-awp-product-card-placement]'),
        finish: card.querySelector('[data-awp-product-card-finish]'),
        price: card.querySelector('[data-awp-product-card-price]')
      }));
      const empty = root.querySelector('[data-awp-empty]');
      const details = root.querySelector('[data-awp-details]');
      const title = root.querySelector('[data-awp-title]');
      const artistText = root.querySelector('[data-awp-artist]');
      const styleText = root.querySelector('[data-awp-style]');
      const priceText = root.querySelector('[data-awp-price]');
      const productLink = root.querySelector('[data-awp-product-link]');
      const counter = root.querySelector('[data-awp-counter]');
      const live = root.querySelector('[data-awp-live]');
      const progress = root.querySelector('[data-awp-progress]');
      const previousButton = root.querySelector('[data-awp-previous]');
      const nextButton = root.querySelector('[data-awp-next]');
      const toggleButton = root.querySelector('[data-awp-toggle]');
      const settingsButton = root.querySelector('[data-awp-open-settings]');
      const settingsDialog = root.querySelector('[data-awp-dialog]');
      const artistFilter = root.querySelector('[data-awp-artist-filter]');
      const styleFilter = root.querySelector('[data-awp-style-filter]');
      const modeFilter = root.querySelector('[data-awp-mode]');
      const itemsPerScreenFilter = root.querySelector('[data-awp-items-per-screen]');
      const intervalInput = root.querySelector('[data-awp-interval]');
      const intervalOutput = root.querySelector('[data-awp-interval-output]');
      const randomAllButton = root.querySelector('[data-awp-random-all]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const collator = new Intl.Collator(document.documentElement.lang || undefined, { sensitivity: 'base' });

      let works = [];
      try {
        works = JSON.parse(dataNode ? dataNode.textContent : '[]');
      } catch (error) {
        works = [];
      }
      const maxWorks = Math.max(1, Number(root.dataset.maxWorks) || 500);
      works = works
        .filter((work) => work && work.id && ((work.mediaType === 'video' && work.sources && work.sources.length) || work.image))
        .slice(0, maxWorks);
      const allowedItemsPerScreen = new Set([1, 2, 4]);
      const multiItemViewEnabled = root.dataset.multiItemView === 'true'
        && Boolean(productGrid)
        && productCards.length === 4;
      const requestedItemsPerScreen = Number(root.dataset.defaultItemsPerScreen);
      let itemsPerScreen = multiItemViewEnabled && allowedItemsPerScreen.has(requestedItemsPerScreen)
        ? requestedItemsPerScreen
        : 1;
      root.dataset.itemsPerScreen = String(itemsPerScreen);
      if (itemsPerScreenFilter) itemsPerScreenFilter.value = String(itemsPerScreen);

      let pool = [];
      let deck = [];
      let deckIndex = -1;
      let current = null;
      let currentItems = [];
      let mediaRenderVersion = 0;
      let timerId = 0;
      let deadline = 0;
      let remainingMs = Math.max(2, Number(root.dataset.defaultInterval) || 5) * 1000;
      let intervalMs = remainingMs;
      const VIDEO_END_DELAY_MS = 1000;
      let videoEndTimerId = 0;
      let videoEndDeadline = 0;
      let videoEndRemainingMs = VIDEO_END_DELAY_MS;
      let videoEnded = false;
      let progressAnimation = null;
      let preloadImage = null;
      let preloadImages = [];
      let idleTimer = 0;
      let userPaused = root.dataset.autoplay !== 'true';
      let hiddenSuspended = document.hidden;
      let dialogSuspended = false;
      let productFocusSuspended = false;
      let motionOverride = false;
      let motionSuspended = reducedMotion.matches;
      let previousBodyOverflow = document.body.style.overflow;
      let lastSettingsTrigger = null;

      const isolatedElements = [document.getElementById('header-group'), document.querySelector('body > footer')]
        .filter(Boolean)
        .map((element) => ({
          element,
          inert: element.inert,
          ariaHidden: element.getAttribute('aria-hidden')
        }));

      document.body.style.overflow = 'hidden';
      isolatedElements.forEach(({ element }) => {
        element.inert = true;
        element.setAttribute('aria-hidden', 'true');
      });

      const format = (template, replacements) => {
        return Object.entries(replacements).reduce((value, [key, replacement]) => value.split(key).join(String(replacement)), template || '');
      };

      const isPlaying = () => {
        return Boolean(current && pool.length && !userPaused && !hiddenSuspended && !dialogSuspended && !productFocusSuspended && !motionSuspended);
      };

      const isCurrentVideo = () => {
        return Boolean(itemsPerScreen === 1 && current && current.mediaType === 'video');
      };

      const updatePlayState = () => {
        const playing = isPlaying();
        root.dataset.playing = playing ? 'true' : 'false';
        if (toggleButton) {
          const label = playing ? root.dataset.labelPause : root.dataset.labelResume;
          toggleButton.setAttribute('aria-label', label || '');
          toggleButton.title = label || '';
        }
      };

      const cancelProgressAnimation = () => {
        if (progressAnimation) {
          progressAnimation.cancel();
          progressAnimation = null;
        }
      };

      const pauseClock = (preserve, updateProgress = true) => {
        if (timerId) {
          if (preserve && deadline) remainingMs = Math.max(0, deadline - performance.now());
          window.clearTimeout(timerId);
          timerId = 0;
        }
        deadline = 0;
        cancelProgressAnimation();
        if (updateProgress) {
          const fraction = intervalMs ? Math.min(1, Math.max(0, 1 - remainingMs / intervalMs)) : 0;
          if (progress) progress.style.transform = `scaleX(${fraction})`;
        }
      };

      const pauseVideoEndDelay = (preserve) => {
        if (videoEndTimerId) {
          if (preserve && videoEndDeadline) {
            videoEndRemainingMs = Math.max(0, videoEndDeadline - performance.now());
          }
          window.clearTimeout(videoEndTimerId);
          videoEndTimerId = 0;
        }
        videoEndDeadline = 0;
      };

      const resetVideoEndDelay = () => {
        pauseVideoEndDelay(false);
        videoEnded = false;
        videoEndRemainingMs = VIDEO_END_DELAY_MS;
      };

      const pauseVideo = () => {
        if (video && !video.paused) video.pause();
      };

      const playVideo = () => {
        if (!video || video.hidden || !isCurrentVideo() || videoEnded || !isPlaying()) return;
        video.muted = true;
        video.defaultMuted = true;
        video.autoplay = true;
        video.loop = false;
        video.playsInline = true;
        if (!video.paused) return;
        const attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') attempt.catch(() => {});
      };

      const scheduleVideoEndDelay = () => {
        if (!isPlaying() || !isCurrentVideo() || !videoEnded || videoEndTimerId) return;
        const duration = Math.max(0, videoEndRemainingMs);
        const endedWorkId = current.id;
        videoEndDeadline = performance.now() + duration;
        videoEndTimerId = window.setTimeout(() => {
          videoEndTimerId = 0;
          videoEndDeadline = 0;
          videoEndRemainingMs = VIDEO_END_DELAY_MS;
          if (!current || current.id !== endedWorkId || !videoEnded) return;
          videoEnded = false;
          showNext(true);
        }, duration);
      };

      const scheduleClock = () => {
        if (!isPlaying() || timerId) return;
        const duration = Math.max(80, remainingMs || intervalMs);
        const startFraction = intervalMs ? Math.min(1, Math.max(0, 1 - duration / intervalMs)) : 0;
        deadline = performance.now() + duration;
        if (progress && typeof progress.animate === 'function') {
          cancelProgressAnimation();
          progressAnimation = progress.animate(
            [{ transform: `scaleX(${startFraction})` }, { transform: 'scaleX(1)' }],
            { duration, easing: 'linear', fill: 'forwards' }
          );
        }
        timerId = window.setTimeout(() => {
          timerId = 0;
          deadline = 0;
          remainingMs = intervalMs;
          showNext(true);
        }, duration);
      };

      const updatePlayback = () => {
        updatePlayState();
        if (!isPlaying()) {
          pauseVideo();
          pauseClock(!isCurrentVideo(), !isCurrentVideo());
          pauseVideoEndDelay(true);
          return;
        }
        if (isCurrentVideo()) {
          pauseClock(false, false);
          if (videoEnded) {
            pauseVideo();
            scheduleVideoEndDelay();
          } else {
            playVideo();
          }
        } else {
          pauseVideoEndDelay(false);
          pauseVideo();
          scheduleClock();
        }
      };

      const handleVideoCanPlay = () => {
        if (isCurrentVideo() && !videoEnded) playVideo();
      };

      const handleVideoPlay = () => {
        if (!isCurrentVideo() || !isPlaying() || videoEnded) pauseVideo();
      };

      const handleVideoEnded = () => {
        if (!isCurrentVideo()) return;
        videoEnded = true;
        pauseClock(false, false);
        pauseVideoEndDelay(false);
        videoEndRemainingMs = VIDEO_END_DELAY_MS;
        if (progress) progress.style.transform = 'scaleX(1)';
        scheduleVideoEndDelay();
      };

      const handleVideoTimeUpdate = () => {
        if (!video || !isCurrentVideo() || videoEnded) return;
        const duration = Number(video.duration);
        if (!Number.isFinite(duration) || duration <= 0) return;
        const fraction = Math.min(1, Math.max(0, video.currentTime / duration));
        if (progress) progress.style.transform = `scaleX(${fraction})`;
      };

      const shuffle = (items) => {
        const result = items.slice();
        for (let index = result.length - 1; index > 0; index -= 1) {
          const swapIndex = Math.floor(Math.random() * (index + 1));
          [result[index], result[swapIndex]] = [result[swapIndex], result[index]];
        }
        return result;
      };

      const nextCandidate = () => {
        if (!deck.length) return null;
        const nextIndex = deckIndex + 1;
        if (nextIndex < deck.length) return deck[nextIndex];
        return modeFilter && modeFilter.value === 'shuffle' ? deck[0] : deck[0];
      };

      const preloadNext = () => {
        preloadImage = null;
        preloadImages = [];
        if (itemsPerScreen > 1) {
          if (!deck.length) return;
          const nextStart = deckIndex + itemsPerScreen < deck.length ? deckIndex + itemsPerScreen : 0;
          deck.slice(nextStart, nextStart + itemsPerScreen).forEach((candidate) => {
            const source = candidate.image || candidate.poster;
            if (!source) return;
            const nextImage = new Image();
            nextImage.decoding = 'async';
            nextImage.src = source;
            preloadImages.push(nextImage);
          });
          return;
        }
        const candidate = nextCandidate();
        if (!candidate) return;
        const source = candidate.mediaType === 'video' ? candidate.poster : candidate.image;
        if (!source) return;
        preloadImage = new Image();
        preloadImage.decoding = 'async';
        preloadImage.src = source;
      };

      const clearVideoSources = () => {
        if (!video) return;
        pauseVideo();
        video.removeAttribute('src');
        video.removeAttribute('poster');
        while (video.firstChild) video.removeChild(video.firstChild);
        video.load();
      };

      const clearProductCards = () => {
        productCards.forEach(({ card, image: cardImage, title: cardTitle, placement, finish, price }) => {
          card.hidden = true;
          card.removeAttribute('href');
          card.removeAttribute('aria-label');
          delete card.dataset.workId;
          if (cardImage) {
            cardImage.removeAttribute('src');
            cardImage.alt = '';
          }
          if (cardTitle) cardTitle.textContent = '';
          if (placement) placement.textContent = '';
          if (finish) finish.textContent = '';
          if (price) price.textContent = '';
        });
      };

      const showSingletonPresentation = () => {
        if (productGrid) productGrid.hidden = true;
        clearProductCards();
        if (mediaShell) mediaShell.hidden = false;
        if (details) details.hidden = false;
      };

      const renderProductGrid = (items) => {
        clearVideoSources();
        if (video) video.hidden = true;
        if (videoBadge) videoBadge.hidden = true;
        if (image) {
          image.hidden = true;
          image.removeAttribute('src');
        }
        if (mediaShell) mediaShell.hidden = true;
        if (details) details.hidden = true;
        clearProductCards();
        productCards.forEach(({ card, image: cardImage, title: cardTitle, placement, finish, price }, index) => {
          const work = items[index];
          if (!work) return;
          card.dataset.workId = String(work.id);
          if (work.url) card.href = work.url;
          const accessibleLabel = [work.title, work.artist, work.style, work.price].filter(Boolean).join(', ');
          if (accessibleLabel) card.setAttribute('aria-label', accessibleLabel);
          if (cardImage) {
            cardImage.alt = work.alt || work.title || '';
            cardImage.src = work.image || work.poster || '';
          }
          if (cardTitle) cardTitle.textContent = work.title || '';
          if (placement) placement.textContent = work.artist || '';
          if (finish) finish.textContent = work.style || '';
          if (price) price.textContent = work.price || '';
          card.hidden = false;
        });
        if (productGrid) productGrid.hidden = false;
      };

      const videoSourcePriority = (sourceData) => {
        const type = String(sourceData?.type || '').toLowerCase();
        const url = String(sourceData?.url || '').toLowerCase();
        if (type === 'video/mp4' || /\.mp4(?:\?|$)/.test(url)) return 0;
        if (type.includes('mpegurl') || /\.m3u8(?:\?|$)/.test(url)) return 2;
        return 1;
      };

      const renderMedia = (work) => {
        clearVideoSources();
        if (work.mediaType === 'video' && work.sources && work.sources.length) {
          if (image) {
            image.hidden = true;
            image.removeAttribute('src');
          }
          if (video) {
            video.muted = true;
            video.defaultMuted = true;
            video.autoplay = true;
            video.loop = false;
            video.playsInline = true;
            video.preload = 'auto';
            work.sources.slice().sort((left, right) => videoSourcePriority(left) - videoSourcePriority(right)).forEach((sourceData) => {
              const source = document.createElement('source');
              source.src = sourceData.url;
              if (sourceData.type) source.type = sourceData.type;
              video.appendChild(source);
            });
            if (work.poster) video.poster = work.poster;
            video.hidden = false;
            video.load();
            playVideo();
          }
          if (videoBadge) videoBadge.hidden = false;
        } else {
          if (video) video.hidden = true;
          if (videoBadge) videoBadge.hidden = true;
          if (image) {
            image.alt = work.alt || work.title || '';
            image.src = work.image;
            image.hidden = false;
          }
        }
      };

      const updateDetails = (work) => {
        if (title) title.textContent = work.title || '';
        if (artistText) artistText.textContent = work.artist || '';
        if (styleText) styleText.textContent = work.style || '';
        if (priceText) {
          priceText.textContent = work.price || '';
          priceText.hidden = !work.price;
        }
        if (productLink) {
          productLink.hidden = !work.url;
          if (work.url) {
            productLink.href = work.url;
          } else {
            productLink.removeAttribute('href');
          }
        }
        if (counter) {
          counter.textContent = format(root.dataset.labelCounter, {
            __CURRENT__: Math.max(0, deckIndex + 1),
            __TOTAL__: pool.length
          });
        }
        if (live) {
          const parts = [work.title || ''];
          if (work.artist) parts.push(format(root.dataset.labelArtist, { __ARTIST__: work.artist }));
          if (work.style) parts.push(format(root.dataset.labelStyle, { __STYLE__: work.style }));
          live.textContent = parts.filter(Boolean).join('. ');
        }
      };

      const updateGroupDetails = (items, announce) => {
        const rangeStart = Math.max(0, deckIndex + 1);
        const rangeEnd = Math.min(pool.length, deckIndex + items.length);
        const currentRange = rangeStart === rangeEnd ? rangeStart : `${rangeStart}\u2013${rangeEnd}`;
        if (counter) {
          counter.textContent = format(root.dataset.labelCounter, {
            __CURRENT__: currentRange,
            __TOTAL__: pool.length
          });
        }
        if (live) {
          const firstTitle = items[0]?.title || '';
          live.textContent = announce
            ? [counter ? counter.textContent : '', firstTitle].filter(Boolean).join('. ')
            : '';
        }
      };

      const resetClock = () => {
        pauseClock(false);
        remainingMs = intervalMs;
        if (progress) progress.style.transform = 'scaleX(0)';
      };

      const showWork = (work, announce) => {
        if (!work) return;
        const switchingFromProductGrid = root.dataset.mediaType === 'grid';
        current = work;
        mediaRenderVersion += 1;
        const renderVersion = mediaRenderVersion;
        root.dataset.mediaType = work.mediaType === 'video' ? 'video' : 'image';
        root.dataset.workId = work.id;
        resetClock();
        resetVideoEndDelay();
        const commit = () => {
          if (renderVersion !== mediaRenderVersion || current?.id !== work.id) return;
          renderMedia(work);
        };
        if (document.startViewTransition && !reducedMotion.matches && !switchingFromProductGrid) {
          const transition = document.startViewTransition(commit);
          transition.ready?.catch(() => {});
        } else {
          commit();
        }
        updateDetails(work);
        if (!announce && live) live.textContent = '';
        empty.hidden = true;
        preloadNext();
        updatePlayback();
      };

      const showProductGroup = (startIndex, announce) => {
        deckIndex = Math.max(0, Math.min(startIndex, deck.length - 1));
        currentItems = deck.slice(deckIndex, deckIndex + itemsPerScreen);
        if (!currentItems.length) return;
        current = currentItems[0];
        mediaRenderVersion += 1;
        root.dataset.mediaType = 'grid';
        root.dataset.workId = currentItems.map((work) => work.id).join(',');
        resetClock();
        resetVideoEndDelay();
        renderProductGrid(currentItems);
        updateGroupDetails(currentItems, announce);
        empty.hidden = true;
        preloadNext();
        updatePlayback();
      };

      const showDeckPosition = (startIndex, announce) => {
        if (!deck.length) return;
        const safeIndex = Math.max(0, Math.min(startIndex, deck.length - 1));
        deckIndex = safeIndex;
        if (itemsPerScreen === 1) {
          currentItems = [deck[deckIndex]];
          showSingletonPresentation();
          showWork(deck[deckIndex], announce);
          return;
        }
        showProductGroup(deckIndex, announce);
      };

      const buildDeck = (preferred) => {
        const shuffleMode = !modeFilter || modeFilter.value === 'shuffle';
        deck = shuffleMode ? shuffle(pool) : pool.slice();
        deckIndex = -1;
        if (preferred) {
          const preferredIndex = deck.findIndex((work) => work.id === preferred.id);
          if (preferredIndex >= 0) {
            if (shuffleMode) {
              const selected = deck.splice(preferredIndex, 1)[0];
              deck.unshift(selected);
              deckIndex = 0;
            } else {
              deckIndex = preferredIndex;
            }
          }
        }
      };

      const showNext = (announce) => {
        if (!deck.length) return;
        if (itemsPerScreen > 1) {
          let nextIndex = deckIndex + itemsPerScreen;
          if (nextIndex >= deck.length) {
            if (!modeFilter || modeFilter.value === 'shuffle') {
              const previousIds = new Set(currentItems.map((work) => work.id));
              const shuffled = shuffle(pool);
              const fresh = shuffled.filter((work) => !previousIds.has(work.id));
              const repeated = shuffled.filter((work) => previousIds.has(work.id));
              deck = fresh.concat(repeated);
            }
            nextIndex = 0;
          }
          showDeckPosition(nextIndex, announce);
          return;
        }
        let nextIndex = deckIndex + 1;
        if (nextIndex >= deck.length) {
          if (!modeFilter || modeFilter.value === 'shuffle') {
            const previousWork = current;
            deck = shuffle(pool);
            if (deck.length > 1 && previousWork && deck[0].id === previousWork.id) {
              [deck[0], deck[1]] = [deck[1], deck[0]];
            }
          }
          nextIndex = 0;
        }
        deckIndex = nextIndex;
        showDeckPosition(deckIndex, announce);
      };

      const showPrevious = () => {
        if (!deck.length) return;
        if (itemsPerScreen > 1) {
          const lastGroupStart = Math.floor((deck.length - 1) / itemsPerScreen) * itemsPerScreen;
          const previousIndex = deckIndex - itemsPerScreen;
          showDeckPosition(previousIndex < 0 ? lastGroupStart : previousIndex, true);
          return;
        }
        deckIndex = deckIndex <= 0 ? deck.length - 1 : deckIndex - 1;
        showDeckPosition(deckIndex, true);
      };

      const setItemsPerScreen = (requestedCount) => {
        const nextCount = Number(requestedCount);
        if (!multiItemViewEnabled || !allowedItemsPerScreen.has(nextCount)) return;
        if (nextCount === itemsPerScreen) return;
        if (deck.length && current) {
          const currentIndex = deck.findIndex((work) => work.id === current.id);
          if (currentIndex > 0) deck = deck.slice(currentIndex).concat(deck.slice(0, currentIndex));
        }
        itemsPerScreen = nextCount;
        root.dataset.itemsPerScreen = String(itemsPerScreen);
        if (itemsPerScreenFilter) itemsPerScreenFilter.value = String(itemsPerScreen);
        if (deck.length) showDeckPosition(0, false);
      };

      const setEmptyState = () => {
        current = null;
        currentItems = [];
        mediaRenderVersion += 1;
        root.dataset.mediaType = 'empty';
        delete root.dataset.workId;
        deck = [];
        deckIndex = -1;
        resetClock();
        resetVideoEndDelay();
        clearVideoSources();
        clearProductCards();
        if (productGrid) productGrid.hidden = true;
        if (mediaShell) mediaShell.hidden = false;
        if (details) details.hidden = false;
        if (video) video.hidden = true;
        if (image) {
          image.hidden = true;
          image.removeAttribute('src');
        }
        if (videoBadge) videoBadge.hidden = true;
        if (empty) empty.hidden = false;
        if (title) title.textContent = '';
        if (artistText) artistText.textContent = '';
        if (styleText) styleText.textContent = '';
        if (priceText) {
          priceText.textContent = '';
          priceText.hidden = true;
        }
        if (productLink) {
          productLink.hidden = true;
          productLink.removeAttribute('href');
        }
        if (counter) counter.textContent = format(root.dataset.labelCounter, { __CURRENT__: 0, __TOTAL__: 0 });
        updatePlayback();
      };

      const applyFilters = (preserveCurrent) => {
        const artistKey = artistFilter ? artistFilter.value : '';
        const styleKey = styleFilter ? styleFilter.value : '';
        pool = works.filter((work) => {
          const artistMatches = !artistKey
            || work.artistKey === artistKey
            || (Array.isArray(work.artistKeys) && work.artistKeys.includes(artistKey));
          return artistMatches && (!styleKey || work.styleKey === styleKey);
        });
        if (!pool.length) {
          setEmptyState();
          return;
        }
        const preferred = preserveCurrent && current && pool.some((work) => work.id === current.id) ? current : null;
        buildDeck(preferred);
        if (preferred) {
          if (itemsPerScreen > 1 && deckIndex > 0) {
            deck = deck.slice(deckIndex).concat(deck.slice(0, deckIndex));
            deckIndex = 0;
          }
          showDeckPosition(deckIndex, false);
        } else {
          showDeckPosition(0, true);
        }
      };

      const populateFilter = (select, keyName, labelName) => {
        if (!select) return;
        const labels = new Map();
        works.forEach((work) => {
          if (keyName === 'artistKey' && Array.isArray(work.artistKeys) && Array.isArray(work.artistLabels)) {
            work.artistKeys.forEach((key, index) => {
              const label = work.artistLabels[index];
              if (key && label && !labels.has(key)) labels.set(key, label);
            });
          }
          if (work[keyName] && work[labelName] && !labels.has(work[keyName])) labels.set(work[keyName], work[labelName]);
        });
        Array.from(labels.entries())
          .sort((left, right) => collator.compare(left[1], right[1]))
          .forEach(([value, label]) => select.add(new Option(label, value)));
      };

      const populateFilters = () => {
        const artistValue = artistFilter ? artistFilter.value : '';
        const styleValue = styleFilter ? styleFilter.value : '';
        if (artistFilter) {
          while (artistFilter.options.length > 1) artistFilter.remove(1);
          populateFilter(artistFilter, 'artistKey', 'artist');
          artistFilter.value = Array.from(artistFilter.options).some((option) => option.value === artistValue) ? artistValue : '';
        }
        if (styleFilter) {
          while (styleFilter.options.length > 1) styleFilter.remove(1);
          populateFilter(styleFilter, 'styleKey', 'style');
          styleFilter.value = Array.from(styleFilter.options).some((option) => option.value === styleValue) ? styleValue : '';
        }
      };

      const loadRemainingPages = async () => {
        const pageCount = Math.max(1, Number(root.dataset.pageCount) || 1);
        const currentPage = Math.max(1, Number(root.dataset.currentPage) || 1);
        const pageParam = root.dataset.pageParam || 'page';
        if (pageCount <= 1 || works.length >= maxWorks) return;

        const requests = [];
        for (let pageNumber = 1; pageNumber <= pageCount; pageNumber += 1) {
          if (pageNumber === currentPage) continue;
          const pageUrl = new URL(window.location.href);
          pageUrl.searchParams.set(pageParam, String(pageNumber));
          pageUrl.hash = '';
          requests.push(
            fetch(pageUrl, { credentials: 'same-origin', headers: { Accept: 'text/html' } })
              .then((response) => response.ok ? response.text() : '')
              .then((html) => {
                if (!html) return [];
                const parsed = new DOMParser().parseFromString(html, 'text/html');
                const remoteData = parsed.querySelector('[data-artist-work-player] [data-awp-data]');
                if (!remoteData) return [];
                try {
                  return JSON.parse(remoteData.textContent || '[]');
                } catch (error) {
                  return [];
                }
              })
          );
        }

        const settled = await Promise.allSettled(requests);
        const merged = new Map(works.map((work) => [work.id, work]));
        settled.forEach((result) => {
          if (result.status !== 'fulfilled') return;
          result.value.forEach((work) => {
            if (work && work.id && ((work.mediaType === 'video' && work.sources && work.sources.length) || work.image)) {
              merged.set(work.id, work);
            }
          });
        });
        works = Array.from(merged.values()).slice(0, maxWorks);
        populateFilters();
        applyFilters(true);
      };

      const wakeControls = () => {
        root.dataset.idle = 'false';
        if (idleTimer) window.clearTimeout(idleTimer);
        if (isPlaying() && !settingsDialog.open) {
          idleTimer = window.setTimeout(() => {
            if (isPlaying() && !settingsDialog.open && !root.matches(':focus-within')) root.dataset.idle = 'true';
          }, 3600);
        }
      };

      const togglePlayback = () => {
        if (!pool.length) return;
        if (isPlaying()) {
          userPaused = true;
        } else {
          userPaused = false;
          motionOverride = true;
          motionSuspended = false;
        }
        updatePlayback();
        wakeControls();
      };

      const openSettings = () => {
        if (!settingsDialog || settingsDialog.open) return;
        lastSettingsTrigger = document.activeElement;
        dialogSuspended = true;
        root.dataset.dialogOpen = 'true';
        updatePlayback();
        settingsDialog.showModal();
        wakeControls();
      };

      const closeSettings = () => {
        dialogSuspended = false;
        root.dataset.dialogOpen = 'false';
        updatePlayback();
        if (lastSettingsTrigger && typeof lastSettingsTrigger.focus === 'function') lastSettingsTrigger.focus();
        wakeControls();
      };

      const handleVisibility = () => {
        hiddenSuspended = document.hidden;
        updatePlayback();
      };

      const handleReducedMotion = () => {
        motionSuspended = reducedMotion.matches && !motionOverride;
        updatePlayback();
      };

      const handleFocusIn = () => {
        wakeControls();
        const shouldSuspend = Boolean(root.querySelector('[data-awp-product-card]:focus, [data-awp-product-link]:focus'));
        if (shouldSuspend === productFocusSuspended) return;
        productFocusSuspended = shouldSuspend;
        updatePlayback();
      };

      const handleFocusOut = () => {
        queueMicrotask(() => {
          const shouldSuspend = Boolean(root.querySelector('[data-awp-product-card]:focus, [data-awp-product-link]:focus'));
          if (shouldSuspend === productFocusSuspended) return;
          productFocusSuspended = shouldSuspend;
          updatePlayback();
        });
      };

      const handleKeydown = (event) => {
        if (settingsDialog && settingsDialog.open) return;
        const target = event.target;
        if (target?.closest?.('input, select, textarea, [contenteditable="true"]')) return;
        if (event.key === ' ' || event.code === 'Space') {
          if (target?.closest?.('button, a')) return;
          event.preventDefault();
          togglePlayback();
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          showNext(true);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          showPrevious();
        }
      };

      populateFilters();

      if (intervalInput) {
        intervalInput.value = String(Math.max(2, Math.min(15, Number(root.dataset.defaultInterval) || 5)));
        intervalOutput.textContent = `${intervalInput.value}${intervalOutput.textContent.replace(/[\d\s]/g, '')}`;
      }

      previousButton?.addEventListener('click', showPrevious);
      nextButton?.addEventListener('click', () => showNext(true));
      toggleButton?.addEventListener('click', togglePlayback);
      settingsButton?.addEventListener('click', openSettings);
      artistFilter?.addEventListener('change', () => applyFilters(false));
      styleFilter?.addEventListener('change', () => applyFilters(false));
      modeFilter?.addEventListener('change', () => applyFilters(true));
      itemsPerScreenFilter?.addEventListener('change', () => {
        setItemsPerScreen(itemsPerScreenFilter.value);
        wakeControls();
      });
      intervalInput?.addEventListener('input', () => {
        const suffix = intervalOutput.textContent.replace(/[\d\s]/g, '');
        intervalOutput.textContent = `${intervalInput.value}${suffix}`;
      });
      intervalInput?.addEventListener('change', () => {
        intervalMs = Math.max(2, Math.min(15, Number(intervalInput.value) || 5)) * 1000;
        resetClock();
        updatePlayback();
      });
      randomAllButton?.addEventListener('click', () => {
        if (artistFilter) artistFilter.value = '';
        if (styleFilter) styleFilter.value = '';
        if (modeFilter) modeFilter.value = 'shuffle';
        userPaused = false;
        motionOverride = true;
        motionSuspended = false;
        applyFilters(false);
        if (settingsDialog && settingsDialog.open) settingsDialog.close();
      });
      settingsDialog?.addEventListener('close', closeSettings);
      settingsDialog?.addEventListener('click', (event) => {
        if (event.target === settingsDialog) settingsDialog.close();
      });
      document.addEventListener('visibilitychange', handleVisibility);
      document.addEventListener('keydown', handleKeydown);
      reducedMotion.addEventListener?.('change', handleReducedMotion);
      video?.addEventListener('canplay', handleVideoCanPlay);
      video?.addEventListener('play', handleVideoPlay);
      video?.addEventListener('ended', handleVideoEnded);
      video?.addEventListener('timeupdate', handleVideoTimeUpdate);
      root.addEventListener('pointermove', wakeControls, { passive: true });
      root.addEventListener('pointerdown', wakeControls, { passive: true });
      root.addEventListener('focusin', handleFocusIn);
      root.addEventListener('focusout', handleFocusOut);

      applyFilters(false);
      updatePlayback();
      wakeControls();
      loadRemainingPages().catch(() => {});

      root.awpCleanup = () => {
        mediaRenderVersion += 1;
        pauseClock(false);
        pauseVideoEndDelay(false);
        pauseVideo();
        preloadImage = null;
        preloadImages = [];
        if (idleTimer) window.clearTimeout(idleTimer);
        document.removeEventListener('visibilitychange', handleVisibility);
        document.removeEventListener('keydown', handleKeydown);
        reducedMotion.removeEventListener?.('change', handleReducedMotion);
        video?.removeEventListener('canplay', handleVideoCanPlay);
        video?.removeEventListener('play', handleVideoPlay);
        video?.removeEventListener('ended', handleVideoEnded);
        video?.removeEventListener('timeupdate', handleVideoTimeUpdate);
        root.removeEventListener('focusin', handleFocusIn);
        root.removeEventListener('focusout', handleFocusOut);
        document.body.style.overflow = previousBodyOverflow;
        isolatedElements.forEach(({ element, inert, ariaHidden }) => {
          element.inert = inert;
          if (ariaHidden === null) element.removeAttribute('aria-hidden');
          else element.setAttribute('aria-hidden', ariaHidden);
        });
      };
    };

    const initializeWithin = (scope) => {
      if (scope.matches?.(selector)) initialize(scope);
      scope.querySelectorAll?.(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
    } else {
      initializeWithin(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      const root = event.target.matches?.(selector) ? event.target : event.target.querySelector?.(selector);
      if (root?.awpCleanup) root.awpCleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jewelry-collection"] && !Shopify.designMode) return;
  try {
    
  class UrbanJewelryCollection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') {
        this.reconnectGlobalListeners();
        if (this.dataset.uijEmbedded === 'true' && this.dataset.uijHydrated !== 'true') {
          this.loadEmbeddedCollection(this.embeddedCollectionUrl(window.location.search));
        }
        return;
      }
      this.dataset.initialized = 'true';
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.desktopLayout = window.matchMedia('(min-width: 768px)');
      this.galleryUpdates = [];
      this.setupFacets();
      this.setupSort();
      this.setupGalleries();
      this.setupVariants();
      if (this.dataset.uijEmbedded === 'true') {
        this.setupEmbeddedNavigation();
        if (this.dataset.uijHydrated !== 'true') {
          this.loadEmbeddedCollection(this.embeddedCollectionUrl(window.location.search));
        }
      }
    }

    disconnectedCallback() {
      if (this.syncFacets) this.desktopLayout?.removeEventListener('change', this.syncFacets);
      if (this.handleDocumentClick) document.removeEventListener('click', this.handleDocumentClick);
      if (this.handleGalleryResize) window.removeEventListener('resize', this.handleGalleryResize);
      if (this.handleEmbeddedSubmit) this.removeEventListener('submit', this.handleEmbeddedSubmit);
      if (this.handleEmbeddedClick) this.removeEventListener('click', this.handleEmbeddedClick);
      if (this.handleEmbeddedPopState) window.removeEventListener('popstate', this.handleEmbeddedPopState);
      this.embeddedRequest?.abort();
      this.embeddedRequest = null;
      this.removeAttribute('aria-busy');
    }

    reconnectGlobalListeners() {
      if (this.syncFacets) this.desktopLayout?.addEventListener('change', this.syncFacets);
      if (this.handleDocumentClick) document.addEventListener('click', this.handleDocumentClick);
      if (this.handleGalleryResize) window.addEventListener('resize', this.handleGalleryResize, { passive: true });
      if (this.handleEmbeddedSubmit) this.addEventListener('submit', this.handleEmbeddedSubmit);
      if (this.handleEmbeddedClick) this.addEventListener('click', this.handleEmbeddedClick);
      if (this.handleEmbeddedPopState) window.addEventListener('popstate', this.handleEmbeddedPopState);
    }

    setupEmbeddedNavigation() {
      this.handleEmbeddedSubmit = (event) => {
        const form = event.target instanceof HTMLFormElement ? event.target : null;
        if (!form?.matches('[data-uij-controls]')) return;
        event.preventDefault();

        const target = this.embeddedCollectionUrl();
        const params = new URLSearchParams();
        new FormData(form).forEach((value, key) => {
          if (typeof value === 'string' && value !== '') params.append(key, value);
        });
        this.appendPreviewParams(params);
        target.search = params.toString();
        this.loadEmbeddedCollection(target, {
          updateHistory: true,
          fallbackToCollection: true,
          focusResults: true
        });
      };

      this.handleEmbeddedClick = (event) => {
        const target = event.target instanceof Element ? event.target : null;
        const link = target?.closest(
          '.uij-active a, .uij-pagination a, .uij-empty a, .uij-controls__reset'
        );
        if (!(link instanceof HTMLAnchorElement) || !this.contains(link)) return;

        const collectionUrl = this.embeddedCollectionUrl();
        const requestedUrl = new URL(link.href, window.location.origin);
        if (requestedUrl.origin !== collectionUrl.origin || requestedUrl.pathname !== collectionUrl.pathname) return;

        event.preventDefault();
        this.appendPreviewParams(requestedUrl.searchParams);
        this.loadEmbeddedCollection(requestedUrl, {
          updateHistory: true,
          fallbackToCollection: true,
          focusResults: true,
          scrollToResults: Boolean(link.closest('.uij-pagination, .uij-empty'))
        });
      };

      this.handleEmbeddedPopState = () => {
        if (!this.isConnected) return;
        const target = this.embeddedCollectionUrl(window.location.search);
        if (target.search === (this.dataset.uijCollectionSearch || '')) return;
        this.loadEmbeddedCollection(target, { restoreHistoryOnFailure: true });
      };

      this.addEventListener('submit', this.handleEmbeddedSubmit);
      this.addEventListener('click', this.handleEmbeddedClick);
      window.addEventListener('popstate', this.handleEmbeddedPopState);
    }

    embeddedCollectionUrl(search = '') {
      const url = new URL(
        this.dataset.uijCollectionUrl || '/collections/piercing-jewelry',
        window.location.origin
      );
      url.search = search;
      return url;
    }

    appendPreviewParams(params) {
      const current = new URLSearchParams(window.location.search);
      ['preview_theme_id', '_fd', 'pb'].forEach((key) => {
        if (current.has(key) && !params.has(key)) params.set(key, current.get(key));
      });
    }

    embeddedPageUrl(collectionUrl) {
      const pageUrl = new URL(this.dataset.uijPageUrl || window.location.pathname, window.location.origin);
      pageUrl.search = collectionUrl.search;
      return pageUrl;
    }

    prepareEmbeddedReplacement(source, collectionUrl) {
      const replacement = document.importNode(source, true);
      replacement.dataset.uijEmbedded = 'true';
      replacement.dataset.uijHydrated = 'true';
      replacement.dataset.uijCollectionUrl = this.dataset.uijCollectionUrl || '/collections/piercing-jewelry';
      replacement.dataset.uijPageUrl = this.dataset.uijPageUrl || window.location.pathname;
      replacement.dataset.uijCollectionSearch = collectionUrl.search;

      const title = replacement.querySelector('h1.uij-collection__title');
      if (title instanceof HTMLElement) {
        const heading = document.createElement('h2');
        Array.from(title.attributes).forEach((attribute) => {
          heading.setAttribute(attribute.name, attribute.value);
        });
        heading.innerHTML = title.innerHTML;
        title.replaceWith(heading);
      }

      return replacement;
    }

    async loadEmbeddedCollection(
      requestedUrl,
      {
        updateHistory = false,
        fallbackToCollection = false,
        focusResults = false,
        scrollToResults = false,
        restoreHistoryOnFailure = false
      } = {}
    ) {
      const collectionUrl = this.embeddedCollectionUrl();
      const targetUrl = new URL(requestedUrl, window.location.origin);
      if (targetUrl.origin !== collectionUrl.origin || targetUrl.pathname !== collectionUrl.pathname) return;

      this.embeddedRequest?.abort();
      this.embeddedRequest = new AbortController();
      this.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(targetUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          signal: this.embeddedRequest.signal
        });
        if (!response.ok) throw new Error(`Unable to load jewelry collection (${response.status})`);

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.querySelector('urban-jewelry-collection');
        if (!(source instanceof HTMLElement)) throw new Error('Jewelry collection markup was not found');

        const replacement = this.prepareEmbeddedReplacement(source, targetUrl);
        if (updateHistory) {
          window.history.pushState(
            { urbanJewelryCollection: true },
            '',
            this.embeddedPageUrl(targetUrl)
          );
        }
        if (scrollToResults) {
          this.querySelector('.uij-results-head')?.scrollIntoView({ behavior: 'auto', block: 'center' });
        }
        this.replaceWith(replacement);
        if (focusResults) {
          replacement.querySelector('.uij-results-head')?.focus();
        }
      } catch (error) {
        if (error instanceof DOMException && error.name === 'AbortError') return;
        this.removeAttribute('aria-busy');
        if (restoreHistoryOnFailure) {
          const renderedUrl = this.embeddedCollectionUrl(this.dataset.uijCollectionSearch || '');
          window.history.replaceState(
            { urbanJewelryCollection: true },
            '',
            this.embeddedPageUrl(renderedUrl)
          );
        } else if (fallbackToCollection) {
          window.location.assign(targetUrl);
        }
      }
    }

    setupFacets() {
      const facets = this.querySelector('[data-uij-facets]');
      if (!(facets instanceof HTMLDetailsElement)) return;

      this.syncFacets = () => {
        facets.open = this.desktopLayout.matches;
      };

      this.syncFacets();
      this.desktopLayout.addEventListener('change', this.syncFacets);

      this.querySelectorAll('[data-uij-filter]').forEach((filter) => {
        filter.addEventListener('toggle', () => {
          if (!filter.open || !this.desktopLayout.matches) return;
          this.querySelectorAll('[data-uij-filter][open]').forEach((other) => {
            if (other !== filter) other.removeAttribute('open');
          });
        });
      });

      const form = facets.closest('form');
      this.querySelectorAll('[data-uij-filter] input[type="checkbox"]').forEach((input) => {
        input.addEventListener('change', () => {
          if (this.desktopLayout.matches && form instanceof HTMLFormElement) form.requestSubmit();
        });
      });

      this.handleDocumentClick = (event) => {
        if (!this.desktopLayout.matches) return;
        const clickedFilter = event.target instanceof Element ? event.target.closest('[data-uij-filter]') : null;
        if (clickedFilter && this.contains(clickedFilter)) return;
        this.querySelectorAll('[data-uij-filter][open]').forEach((filter) => filter.removeAttribute('open'));
      };
      document.addEventListener('click', this.handleDocumentClick);

      this.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        this.querySelectorAll('[data-uij-filter][open]').forEach((filter) => filter.removeAttribute('open'));
      });
    }

    setupSort() {
      const sort = this.querySelector('[data-uij-sort]');
      const form = this.querySelector('[data-uij-controls]');
      if (!(sort instanceof HTMLSelectElement) || !(form instanceof HTMLFormElement)) return;
      sort.addEventListener('change', () => form.requestSubmit());
    }

    setupGalleries() {
      this.querySelectorAll('[data-uij-gallery]').forEach((gallery) => {
        const track = gallery.querySelector('[data-uij-media-track]');
        const link = gallery.closest('[data-uij-media-link]');
        const progress = gallery.querySelector('[data-uij-progress]');
        const progressCurrent = gallery.querySelector('[data-uij-progress-current]');
        const status = gallery.querySelector('[data-uij-gallery-status]');
        const slides = Array.from(gallery.querySelectorAll('[data-uij-media-slide]'));
        if (!(track instanceof HTMLElement) || !(link instanceof HTMLAnchorElement) || slides.length < 2) return;

        let frame = 0;
        let touchStartX = 0;
        let touchStartY = 0;
        let suppressClick = false;

        const update = () => {
          frame = 0;
          const width = track.clientWidth || 1;
          const index = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / width)));
          gallery.style.setProperty('--uij-progress-index', String(index));
          if (progress instanceof HTMLElement) progress.dataset.activeIndex = String(index);
          if (progressCurrent instanceof HTMLElement) progressCurrent.textContent = String(index + 1).padStart(2, '0');
          if (status instanceof HTMLElement) status.textContent = slides[index].dataset.uijSlideLabel || '';
        };

        track.addEventListener('scroll', () => {
          if (frame) return;
          frame = window.requestAnimationFrame(update);
        }, { passive: true });

        track.addEventListener('touchstart', (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
          suppressClick = false;
        }, { passive: true });

        track.addEventListener('touchmove', (event) => {
          const touch = event.touches[0];
          if (!touch) return;
          const deltaX = Math.abs(touch.clientX - touchStartX);
          const deltaY = Math.abs(touch.clientY - touchStartY);
          if (deltaX > 8 && deltaX > deltaY) suppressClick = true;
        }, { passive: true });

        link.addEventListener('click', (event) => {
          if (!suppressClick) return;
          event.preventDefault();
          suppressClick = false;
        });

        link.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (track.scrollWidth <= track.clientWidth + 1) return;
          event.preventDefault();
          const current = Math.round(track.scrollLeft / (track.clientWidth || 1));
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const next = Math.max(0, Math.min(slides.length - 1, current + direction));
          track.scrollTo({
            left: next * track.clientWidth,
            behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
          });
        });

        this.galleryUpdates.push(update);
        update();
      });

      if (this.galleryUpdates.length > 0) {
        this.handleGalleryResize = () => this.galleryUpdates.forEach((update) => update());
        window.addEventListener('resize', this.handleGalleryResize, { passive: true });
      }
    }

    setupVariants() {
      this.querySelectorAll('[data-uij-card]').forEach((card) => {
        const picker = card.querySelector('[data-uij-variant-picker]');
        const data = card.querySelector('[data-uij-variant-data]');
        if (!(picker instanceof HTMLElement) || !(data instanceof HTMLScriptElement)) return;

        let variants;
        try {
          variants = JSON.parse(data.textContent || '[]');
        } catch (error) {
          return;
        }

        const selects = Array.from(picker.querySelectorAll('[data-uij-option]'));
        const links = Array.from(card.querySelectorAll('[data-uij-product-link]'));
        const price = card.querySelector('[data-uij-price]');
        const compareAt = card.querySelector('[data-uij-compare-at]');
        const compareAtValue = card.querySelector('[data-uij-compare-at-value]');
        const priceLabel = card.querySelector('[data-uij-price-label]');
        const availability = card.querySelector('[data-uij-availability]');
        const productForm = card.querySelector('[data-uij-product-form]');
        const variantId = card.querySelector('[data-uij-variant-id]');
        const addButton = card.querySelector('.uij-card__add-button');
        const addButtonLabel = addButton?.querySelector('.add-to-cart-text__content > span > span');
        const primaryImage = card.querySelector('.uij-card__image--primary');

        if (primaryImage instanceof HTMLImageElement) {
          primaryImage.dataset.originalSrc = primaryImage.currentSrc || primaryImage.src;
          primaryImage.dataset.originalSrcset = primaryImage.srcset;
          primaryImage.dataset.originalSizes = primaryImage.sizes;
          primaryImage.dataset.originalAlt = primaryImage.alt;
        }

        const syncOptionAvailability = (selectedOptions) => {
          selects.forEach((select, optionIndex) => {
            const selectedPrefix = selectedOptions.slice(0, optionIndex);
            Array.from(select.options).forEach((option) => {
              option.disabled = !variants.some((item) => {
                if (item.options[optionIndex] !== option.value) return false;
                return selectedPrefix.every((value, index) => item.options[index] === value);
              });
            });
          });
        };

        const updateVariant = (changedOptionIndex = -1) => {
          const selectedOptions = selects.map((select) => select.value);
          let variant = variants.find((item) => item.options.every((option, index) => option === selectedOptions[index]));
          if (!variant && changedOptionIndex >= 0) {
            variant = variants.find((item) => item.options[changedOptionIndex] === selectedOptions[changedOptionIndex]);
            if (variant) {
              selects.forEach((select, index) => {
                select.value = variant.options[index];
              });
            }
          }
          if (!variant) return;

          const normalizedOptions = selects.map((select) => select.value);
          syncOptionAvailability(normalizedOptions);

          links.forEach((link) => {
            if (link instanceof HTMLAnchorElement) link.href = variant.url;
          });

          if (price instanceof HTMLElement) price.textContent = variant.price;
          if (compareAtValue instanceof HTMLElement) compareAtValue.textContent = variant.compareAt;
          if (compareAt instanceof HTMLElement) {
            compareAt.hidden = !variant.compareAt;
          }
          if (priceLabel instanceof HTMLElement) {
            const label = variant.compareAt ? priceLabel.dataset.saleLabel : priceLabel.dataset.regularLabel;
            priceLabel.textContent = `${label || ''}\u00a0`;
          }
          if (availability instanceof HTMLElement) availability.hidden = variant.available;
          if (variantId instanceof HTMLInputElement) {
            variantId.value = variant.id;
            variantId.disabled = !variant.available;
          }
          if (addButton instanceof HTMLButtonElement) addButton.disabled = !variant.available;
          if (addButtonLabel instanceof HTMLElement && productForm instanceof HTMLElement) {
            addButtonLabel.textContent = variant.available
              ? productForm.dataset.addLabel || ''
              : productForm.dataset.soldLabel || '';
          }

          if (primaryImage instanceof HTMLImageElement) {
            if (variant.image) {
              primaryImage.src = variant.image;
              primaryImage.removeAttribute('srcset');
              primaryImage.removeAttribute('sizes');
              primaryImage.alt = variant.imageAlt || primaryImage.dataset.originalAlt || '';
            } else {
              primaryImage.src = primaryImage.dataset.originalSrc || primaryImage.src;
              primaryImage.srcset = primaryImage.dataset.originalSrcset || '';
              primaryImage.sizes = primaryImage.dataset.originalSizes || '';
              primaryImage.alt = primaryImage.dataset.originalAlt || '';
            }
          }
        };

        selects.forEach((select, optionIndex) => {
          select.addEventListener('change', () => updateVariant(optionIndex));
        });
        updateVariant();
      });
    }
  }

  if (!customElements.get('urban-jewelry-collection')) {
    customElements.define('urban-jewelry-collection', UrbanJewelryCollection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
  function revealUrbanBlogActiveFilter(scope) {
    scope.querySelectorAll('[data-urban-blog-filters]').forEach((filters) => {
      const activeFilter = filters.querySelector('[aria-current="page"]');

      if (!activeFilter || filters.scrollWidth <= filters.clientWidth) return;

      const targetLeft = activeFilter.offsetLeft - filters.clientWidth / 2 + activeFilter.offsetWidth / 2;
      filters.scrollLeft = Math.max(0, targetLeft);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => revealUrbanBlogActiveFilter(document));
  } else {
    revealUrbanBlogActiveFilter(document);
  }

  document.addEventListener('shopify:section:load', (event) => revealUrbanBlogActiveFilter(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-flash-tattoo"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["piercing-aftercare-guide"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const expandForPrint = () => {
      document.querySelectorAll('.piercing-aftercare details:not([open])').forEach((item) => {
        item.dataset.piercingPrintOpen = 'true';
        item.open = true;
      });
    };

    const restoreAfterPrint = () => {
      document.querySelectorAll('.piercing-aftercare details[data-piercing-print-open]').forEach((item) => {
        item.open = false;
        delete item.dataset.piercingPrintOpen;
      });
    };

    window.addEventListener('beforeprint', expandForPrint);
    window.addEventListener('afterprint', restoreAfterPrint);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tattoo-walk-in-landing"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('walk-in-hero-carousel')) {
    class WalkInHeroCarousel extends HTMLElement {
      connectedCallback() {
        if (this._initialized || this._scheduled) return;
        this._scheduled = true;
        this.dataset.enhancementScheduled = 'true';
        this.onFirstInteraction = () => this.initialize();
        this.addEventListener('pointerdown', this.onFirstInteraction, { once: true, passive: true });
        this.addEventListener('focusin', this.onFirstInteraction, { once: true, passive: true });
        if (typeof window.requestIdleCallback === 'function') {
          this.idleMode = 'idle';
          this.idleHandle = window.requestIdleCallback(() => this.initialize(), { timeout: 1200 });
        } else {
          this.idleMode = 'timeout';
          this.idleHandle = window.setTimeout(() => this.initialize(), 350);
        }
      }

      initialize() {
        if (this._initialized || !this.isConnected) return;
        this.cancelScheduledEnhancement();
        this.track = this.querySelector('[data-walk-in-carousel-track]');
        this.caption = this.querySelector('[data-walk-in-carousel-caption]');
        this.count = this.querySelector('[data-walk-in-carousel-count]');
        this.previousButton = this.querySelector('[data-walk-in-carousel-previous]');
        this.nextButton = this.querySelector('[data-walk-in-carousel-next]');
        this.slides = Array.from(this.querySelectorAll('[data-walk-in-carousel-slide]'));
        if (!this.track || this.slides.length < 2) return;
        this._initialized = true;
        this.dataset.initialized = 'true';

        if (!this._hasRandomized && this.dataset.randomizeAfterFirst === 'true' && this.slides.length > 2) {
          const followingSlides = this.slides.slice(1);
          for (let index = followingSlides.length - 1; index > 0; index -= 1) {
            const randomIndex = Math.floor(Math.random() * (index + 1));
            [followingSlides[index], followingSlides[randomIndex]] = [followingSlides[randomIndex], followingSlides[index]];
          }
          followingSlides.forEach((slide) => this.track.append(slide));
          this.slides = Array.from(this.querySelectorAll('[data-walk-in-carousel-slide]'));
          this._hasRandomized = true;
        }

        const initialWidth = this.track.clientWidth;
        this.currentIndex = initialWidth
          ? Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / initialWidth)))
          : 0;
        this.scrollFrame = 0;
        this.onScroll = () => {
          if (this.scrollFrame) return;
          this.scrollFrame = window.requestAnimationFrame(() => {
            this.scrollFrame = 0;
            const width = this.track.clientWidth;
            if (!width) return;
            const nextIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / width)));
            if (nextIndex !== this.currentIndex) {
              this.currentIndex = nextIndex;
              this.updateStatus();
            }
          });
        };
        this.onPrevious = () => this.goTo(this.currentIndex - 1);
        this.onNext = () => this.goTo(this.currentIndex + 1);
        this.onKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.currentIndex + (event.key === 'ArrowLeft' ? -1 : 1));
        };
        this.onResize = () => this.track.scrollTo({ left: this.currentIndex * this.track.clientWidth, behavior: 'auto' });

        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.track.addEventListener('keydown', this.onKeydown);
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.track);
        this.updateStatus();
      }

      cancelScheduledEnhancement() {
        this.removeEventListener('pointerdown', this.onFirstInteraction);
        this.removeEventListener('focusin', this.onFirstInteraction);
        if (this.idleHandle != null) {
          if (this.idleMode === 'idle' && typeof window.cancelIdleCallback === 'function') {
            window.cancelIdleCallback(this.idleHandle);
          } else {
            window.clearTimeout(this.idleHandle);
          }
        }
        this.idleHandle = null;
        this.idleMode = '';
        this._scheduled = false;
        delete this.dataset.enhancementScheduled;
      }

      disconnectedCallback() {
        this.cancelScheduledEnhancement();
        this.track?.removeEventListener('scroll', this.onScroll);
        this.track?.removeEventListener('keydown', this.onKeydown);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
        window.cancelAnimationFrame(this.scrollFrame || 0);
        this._initialized = false;
        delete this.dataset.initialized;
      }

      goTo(index) {
        const nextIndex = (index + this.slides.length) % this.slides.length;
        this.currentIndex = nextIndex;
        this.track.scrollTo({ left: nextIndex * this.track.clientWidth, behavior: 'auto' });
        this.updateStatus();
      }

      updateStatus() {
        const slide = this.slides[this.currentIndex];
        if (this.caption && slide?.dataset.caption) this.caption.textContent = slide.dataset.caption;
        if (this.count) {
          const current = String(this.currentIndex + 1).padStart(2, '0');
          const total = String(this.slides.length).padStart(2, '0');
          this.count.textContent = `${current} / ${total}`;
        }
      }
    }

    customElements.define('walk-in-hero-carousel', WalkInHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urban-flash-collection"] && !Shopify.designMode) return;
  try {
    
  class UrbanFlashArchive {
    constructor(root) {
      this.root = root;
      this.input = root.querySelector('[data-uiflash-search-input]');
      this.clearButton = root.querySelector('[data-uiflash-search-clear]');
      this.resetButton = root.querySelector('[data-uiflash-search-reset]');
      this.status = root.querySelector('[data-uiflash-search-status]');
      this.grid = root.querySelector('[data-uiflash-grid]');
      this.empty = root.querySelector('[data-uiflash-search-empty]');
      this.pagination = root.querySelector('[data-uiflash-pagination]');
      this.meta = root.querySelector('[data-uiflash-search-meta]');
      this.sectionId = root.dataset.sectionId;
      this.loadPromise = null;
      this.loadedAllPages = false;
      this.debounce = 0;
      this.filterForms = Array.from(root.querySelectorAll('[data-uiflash-filter-form]'));
      this.preserveNavigationContext();

      this.filterForms.forEach((form) => {
        form.addEventListener('change', (event) => this.onFilterChange(event, form));
      });


      if (!this.input || !this.grid || !this.meta) return;

      this.localItems = Array.from(this.grid.querySelectorAll('[data-uiflash-local-item]'));
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('search', () => this.onInput(true));
      this.clearButton?.addEventListener('click', () => this.reset());
      this.resetButton?.addEventListener('click', () => this.reset());
    }

    preserveNavigationContext() {
      const current = new URL(window.location.href);
      const attributionKeys = new Set(['gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'gad_source']);
      const isAttribution = (key) => key.startsWith('utm_') || attributionKeys.has(key);

      this.root.querySelectorAll('.uiflash-offer-navigation a, .uiflash-controls a, .uiflash-pagination a, .uiflash-empty a').forEach((link) => {
        const href = link.getAttribute('href');
        if (!href || href.startsWith('#')) return;
        const target = new URL(href, current);
        if (target.origin !== current.origin) return;
        const keepSort = link.dataset.uiflashPreserveSort === 'true';
        const keptKeys = new Set();
        current.searchParams.forEach((value, key) => {
          if (!isAttribution(key) && !(keepSort && key === 'sort_by')) return;
          if (!keptKeys.has(key)) {
            if (target.searchParams.has(key)) return;
            keptKeys.add(key);
          }
          target.searchParams.append(key, value);
        });
        link.setAttribute('href', `${target.pathname}${target.search}${target.hash}`);
      });

      this.filterForms.forEach((form) => {
        current.searchParams.forEach((value, key) => {
          if (!isAttribution(key) || form.elements.namedItem(key)) return;
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = key;
          input.value = value;
          form.append(input);
        });
      });
    }

    onFilterChange(event, form) {
      const control = event.target;
      if (!(control instanceof HTMLInputElement) && !(control instanceof HTMLSelectElement)) return;
      if (control.disabled || !control.matches('input[type="checkbox"], input[type="radio"], select')) return;
      if (form.dataset.uiflashSubmitting === 'true') return;

      form.dataset.uiflashSubmitting = 'true';
      form.setAttribute('aria-busy', 'true');
      form.requestSubmit();
    }
    normalize(value) {
      return value
        .toLocaleLowerCase()
        .normalize('NFD')
        .replace(/\p{Diacritic}/gu, '')
        .trim();
    }

    onInput(immediate = false) {
      window.clearTimeout(this.debounce);
      const query = this.normalize(this.input.value);
      this.clearButton.hidden = query === '';

      if (query === '') {
        this.showDefault();
        return;
      }

      this.status.textContent = this.root.dataset.searchLoading;
      this.input.setAttribute('aria-busy', 'true');
      this.debounce = window.setTimeout(() => this.search(query), immediate ? 0 : 140);
    }

    async search(query) {
      await this.loadAllPages();
      if (query !== this.normalize(this.input.value)) return;

      const terms = query.split(/\s+/).filter(Boolean);
      const items = Array.from(this.grid.querySelectorAll('.uiflash-grid__item'));
      let count = 0;

      items.forEach((item) => {
        const haystack = this.normalize(item.querySelector('[data-flash-search]')?.dataset.flashSearch || '');
        const match = terms.every((term) => haystack.includes(term));
        item.hidden = !match;
        if (match) count += 1;
      });

      if (this.pagination) this.pagination.hidden = true;
      this.empty.hidden = count !== 0;
      this.status.textContent = count === 0
        ? this.root.dataset.searchEmpty
        : this.root.dataset.searchResults.replace('__count__', String(count));
      this.input.removeAttribute('aria-busy');
    }

    async loadAllPages() {
      if (this.loadedAllPages) return;
      if (this.loadPromise) return this.loadPromise;

      const totalPages = Number(this.meta.dataset.totalPages || 1);
      const currentPage = Number(this.meta.dataset.currentPage || 1);

      this.loadPromise = Promise.all(
        Array.from({ length: totalPages }, (_, index) => index + 1)
          .filter((page) => page !== currentPage)
          .map((page) => this.fetchPage(page))
      ).then((pageItems) => {
        const knownIds = new Set(
          Array.from(this.grid.querySelectorAll('[data-product-id]')).map((item) => item.dataset.productId)
        );

        pageItems.flat().forEach((item) => {
          if (knownIds.has(item.dataset.productId)) return;
          item.removeAttribute('data-uiflash-local-item');
          item.setAttribute('data-uiflash-remote-item', '');
          item.hidden = true;
          knownIds.add(item.dataset.productId);
          this.grid.append(item);
        });

        this.loadedAllPages = true;
        this.preserveNavigationContext();
      }).catch(() => {
        this.loadedAllPages = true;
      });

      return this.loadPromise;
    }

    async fetchPage(page) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', this.sectionId);
      const response = await fetch(url.toString(), { headers: { Accept: 'text/html' } });
      if (!response.ok) return [];
      const html = await response.text();
      const documentFragment = new DOMParser().parseFromString(html, 'text/html');
      return Array.from(documentFragment.querySelectorAll('.uiflash-grid__item'));
    }

    showDefault() {
      this.grid.querySelectorAll('.uiflash-grid__item').forEach((item) => {
        item.hidden = item.hasAttribute('data-uiflash-remote-item');
      });
      if (this.pagination) this.pagination.hidden = false;
      this.empty.hidden = true;
      this.status.textContent = this.root.dataset.searchDefault;
      this.input.removeAttribute('aria-busy');
    }

    reset() {
      this.input.value = '';
      this.clearButton.hidden = true;
      this.showDefault();
      this.input.focus({ preventScroll: true });
    }
  }

  const initUrbanFlashArchives = (scope = document) => {
    scope.querySelectorAll('[data-uiflash-collection]').forEach((root) => {
      if (root.dataset.uiflashSearchReady === 'true') return;
      root.dataset.uiflashSearchReady = 'true';
      new UrbanFlashArchive(root);
    });
  };

  initUrbanFlashArchives();
  document.addEventListener('shopify:section:load', (event) => initUrbanFlashArchives(event.target));
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-uiflash-filter-form]').forEach((form) => {
      delete form.dataset.uiflashSubmitting;
      form.removeAttribute('aria-busy');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urban-home-featured-artist-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urban-featured-artists')) {
    class UrbanFeaturedArtists extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        this.track = this.querySelector('[data-ui-featured-track]');
        this.slides = Array.from(this.querySelectorAll('[data-ui-featured-slide]'));
        this.heading = this.closest('.ui-featured-artist-v2')?.querySelector('[data-ui-featured-heading]');
        this.counter = this.querySelector('[data-ui-featured-counter]');
        this.progress = this.querySelector('[data-ui-featured-progress]');
        this.live = this.querySelector('[data-ui-featured-live]');
        this.previousButton = this.querySelector('[data-ui-featured-previous]');
        this.nextButton = this.querySelector('[data-ui-featured-next]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.positionTemplate = this.dataset.positionTemplate || 'Artist [name], [current] of [total]';
        this.currentIndex = -1;
        this.frame = 0;
        this.dragged = false;
        this.pointerStart = null;

        if (!this.track || !this.slides.length) return;

        this.slides.forEach((slide, index) => {
          const positionLabel = this.positionTemplate
            .replace('[name]', slide.dataset.artistName || '')
            .replace('[current]', String(index + 1))
            .replace('[total]', String(this.slides.length));
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-roledescription', 'slide');
          slide.setAttribute('aria-label', positionLabel);
        });

        this.previousButton?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.nextButton?.addEventListener('click', () => this.goTo(this.currentIndex + 1));
        this.track.addEventListener('keydown', (event) => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex - 1);
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex + 1);
          }
        });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.updateFromScroll();
          });
        }, { passive: true });
        this.track.addEventListener('pointerdown', (event) => {
          this.pointerStart = { x: event.clientX, y: event.clientY };
          this.dragged = false;
        }, { passive: true });
        this.track.addEventListener('pointermove', (event) => {
          if (!this.pointerStart) return;
          const deltaX = Math.abs(event.clientX - this.pointerStart.x);
          const deltaY = Math.abs(event.clientY - this.pointerStart.y);
          if (deltaX > 8 && deltaX > deltaY) this.dragged = true;
        }, { passive: true });
        const finishPointer = () => {
          this.pointerStart = null;
          window.setTimeout(() => { this.dragged = false; }, 0);
        };
        this.track.addEventListener('pointerup', finishPointer, { passive: true });
        this.track.addEventListener('pointercancel', finishPointer, { passive: true });
        this.track.addEventListener('click', (event) => {
          if (!this.dragged || !event.target.closest('a')) return;
          event.preventDefault();
          event.stopImmediatePropagation();
        }, true);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateFromScroll(false));
          this.resizeObserver.observe(this.track);
        }

        this.setActive(0, false);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        window.clearTimeout(this.headingSwapTimer);
      }

      goTo(index) {
        const nextIndex = Math.max(0, Math.min(index, this.slides.length - 1));
        const slide = this.slides[nextIndex];
        if (!slide) return;
        const trackRect = this.track.getBoundingClientRect();
        const slideRect = slide.getBoundingClientRect();
        const left = this.track.scrollLeft + slideRect.left - trackRect.left;
        this.track.scrollTo({
          left,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth'
        });
        this.setActive(nextIndex, true);
      }

      updateFromScroll(announce = true) {
        const trackLeft = this.track.getBoundingClientRect().left;
        let nextIndex = 0;
        let closestDistance = Number.POSITIVE_INFINITY;
        this.slides.forEach((slide, index) => {
          const distance = Math.abs(slide.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            nextIndex = index;
          }
        });
        this.setActive(nextIndex, announce);
      }

      setActive(index, announce) {
        if (index < 0 || index >= this.slides.length) return;
        const previousIndex = this.currentIndex;
        const changed = previousIndex !== index;
        this.currentIndex = index;
        const slide = this.slides[index];
        const artistName = slide.dataset.artistName || '';
        const slideHeading = slide.dataset.heading || artistName;
        const current = String(index + 1).padStart(2, '0');
        const total = String(this.slides.length).padStart(2, '0');

        if (this.heading && slideHeading) {
          const headingChanged = this.heading.textContent !== slideHeading;
          this.heading.textContent = slideHeading;
          if (headingChanged && previousIndex >= 0 && !this.reducedMotion.matches) {
            window.clearTimeout(this.headingSwapTimer);
            this.heading.dataset.uiFeaturedHeadingSwap = 'true';
            this.headingSwapTimer = window.setTimeout(() => {
              delete this.heading.dataset.uiFeaturedHeadingSwap;
            }, 240);
          }
        }
        if (this.counter) this.counter.textContent = `${current} / ${total}`;
        if (this.progress) this.progress.style.setProperty('--ui-featured-progress', (index + 1) / this.slides.length);
        if (this.previousButton) this.previousButton.disabled = index === 0;
        if (this.nextButton) this.nextButton.disabled = index === this.slides.length - 1;
        this.slides.forEach((item, slideIndex) => item.toggleAttribute('data-active', slideIndex === index));
        if (announce && changed && this.live) {
          this.live.textContent = this.positionTemplate
            .replace('[name]', artistName)
            .replace('[current]', String(index + 1))
            .replace('[total]', String(this.slides.length));
        }
      }
    }

    customElements.define('urban-featured-artists', UrbanFeaturedArtists);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urban-home-flash-shuffle"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('urban-flash-preview')) {
    customElements.define(
      'urban-flash-preview',
      class UrbanFlashPreview extends HTMLElement {
        connectedCallback() {
          if (this.dataset.ready === 'true') return;
          this.dataset.ready = 'true';

          const requestedLayout = new URLSearchParams(window.location.search).get('flash_layout');
          if (requestedLayout === 'spotlight' || requestedLayout === 'archive') {
            this.dataset.layout = requestedLayout;
          }

          this.track = this.querySelector('[data-flash-track]');
          this.counter = this.querySelector('[data-flash-counter]');
          this.progress = this.querySelector('[data-flash-progress]');
          this.previousButton = this.querySelector('[data-flash-previous]');
          this.nextButton = this.querySelector('[data-flash-next]');
          this.shuffleButton = this.querySelector('[data-flash-shuffle]');
          this.liveRegion = this.querySelector('[data-flash-live]');
          this.poolTemplate = this.querySelector('[data-flash-pool]');
          this.poolSlides = this.poolTemplate
            ? Array.from(this.poolTemplate.content.querySelectorAll('[data-flash-slide]'))
            : [];
          this.batchSize = Math.max(1, Number.parseInt(this.dataset.batchSize || '6', 10));
          this.poolLoadPromise = null;
          this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.activeIndex = 0;
          this.scrollFrame = 0;
          this.pointerState = null;
          this.suppressClickUntil = 0;
          this.shuffleBusy = false;
          this.handleResize = () => this.updateActive(this.nearestIndex());

          if (!this.track) return;

          this.seedInitialBatch();
          this.refreshSlides();
          this.updateActive(0);

          this.track.addEventListener('scroll', () => this.queueScrollUpdate(), { passive: true });
          this.track.addEventListener('keydown', (event) => this.onKeydown(event));
          this.track.addEventListener('pointerdown', (event) => this.onPointerDown(event));
          this.track.addEventListener('pointermove', (event) => this.onPointerMove(event));
          this.track.addEventListener('pointerup', (event) => this.onPointerEnd(event));
          this.track.addEventListener('pointercancel', (event) => this.onPointerEnd(event));
          this.track.addEventListener(
            'click',
            (event) => {
              if (performance.now() < this.suppressClickUntil && event.target.closest('a')) {
                event.preventDefault();
                event.stopPropagation();
              }
            },
            true
          );

          this.previousButton?.addEventListener('click', () => this.goTo(this.activeIndex - 1));
          this.nextButton?.addEventListener('click', () => this.goTo(this.activeIndex + 1));
          this.shuffleButton?.addEventListener('click', () => this.shuffle());
          window.addEventListener('resize', this.handleResize, { passive: true });

        }

        disconnectedCallback() {
          window.removeEventListener('resize', this.handleResize);
          if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
        }

        refreshSlides() {
          this.slides = Array.from(this.track.querySelectorAll('[data-flash-slide]'));
          const total = this.slides.length;
          this.slides.forEach((slide, index) => {
            const positionText = this.positionText(index, total);
            slide.setAttribute('aria-label', `${slide.dataset.title}, ${positionText}`);
          });
        }

        positionText(index, total) {
          return (this.dataset.positionTemplate || 'slide [current] of [total]')
            .replace('[current]', String(index + 1))
            .replace('[total]', String(total));
        }

        formatCount(value) {
          return String(value).padStart(2, '0');
        }

        updateActive(index, announce = false) {
          if (!this.slides.length) return;
          const safeIndex = Math.max(0, Math.min(index, this.slides.length - 1));
          this.activeIndex = safeIndex;
          this.slides.forEach((slide, slideIndex) => {
            const active = slideIndex === safeIndex;
            const hideInactiveSlide = this.dataset.layout === 'spotlight'
              && (this.dataset.displayDensity === 'tattoo_single' || window.matchMedia('(max-width: 989px)').matches)
              && !active;
            slide.classList.toggle('is-active', active);
            if (active) slide.setAttribute('aria-current', 'true');
            else slide.removeAttribute('aria-current');
            slide.toggleAttribute('inert', hideInactiveSlide);
            if (hideInactiveSlide) slide.setAttribute('aria-hidden', 'true');
            else slide.removeAttribute('aria-hidden');
          });
          if (this.counter) {
            const endIndex = this.visibleEndIndex(safeIndex);
            if (this.isDesktopSpotlight() && endIndex > safeIndex) {
              this.counter.textContent = `${this.formatCount(safeIndex + 1)}–${this.formatCount(endIndex + 1)} / ${this.formatCount(this.slides.length)}`;
            } else {
              this.counter.textContent = `${this.formatCount(safeIndex + 1)} / ${this.formatCount(this.slides.length)}`;
            }
          }
          const progressIndex = this.isDesktopSpotlight() ? this.visibleEndIndex(safeIndex) : safeIndex;
          this.style.setProperty('--ui-flash-progress', String((progressIndex + 1) / this.slides.length));
          if (announce && this.liveRegion) {
            this.liveRegion.textContent = this.positionText(safeIndex, this.slides.length);
          }
        }

        nearestIndex() {
          const padding = Number.parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
          const target = this.track.scrollLeft;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          this.slides.forEach((slide, index) => {
            const snapPoint = slide.offsetLeft - padding;
            const distance = Math.abs(snapPoint - target);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          return closestIndex;
        }

        isDesktopSpotlight() {
          return this.dataset.layout === 'spotlight'
            && this.dataset.displayDensity !== 'tattoo_single'
            && window.matchMedia('(min-width: 990px)').matches;
        }

        maximumStartIndex() {
          if (!this.isDesktopSpotlight()) return this.slides.length - 1;
          const padding = Number.parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          let closestIndex = 0;
          let closestDistance = Number.POSITIVE_INFINITY;
          this.slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - padding - maximum);
            if (distance < closestDistance) {
              closestDistance = distance;
              closestIndex = index;
            }
          });
          return closestIndex;
        }

        visibleEndIndex(startIndex) {
          if (!this.isDesktopSpotlight()) return startIndex;
          const paddingRight = Number.parseFloat(getComputedStyle(this.track).paddingRight) || 0;
          const viewportEnd = this.track.scrollLeft + this.track.clientWidth - paddingRight + 1;
          let endIndex = startIndex;
          this.slides.forEach((slide, index) => {
            if (index >= startIndex && slide.offsetLeft + slide.offsetWidth <= viewportEnd) endIndex = index;
          });
          return endIndex;
        }

        queueScrollUpdate() {
          if (this.scrollFrame) return;
          this.scrollFrame = requestAnimationFrame(() => {
            this.scrollFrame = 0;
            this.updateActive(this.nearestIndex());
          });
        }

        goTo(index, behavior) {
          if (!this.slides.length) return;
          const maximumStartIndex = this.maximumStartIndex();
          let normalizedIndex;
          if (this.isDesktopSpotlight()) {
            if (index > maximumStartIndex) normalizedIndex = 0;
            else if (index < 0) normalizedIndex = maximumStartIndex;
            else normalizedIndex = index;
          } else {
            normalizedIndex = (index + this.slides.length) % this.slides.length;
          }
          const slide = this.slides[normalizedIndex];
          const padding = Number.parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
          const left = slide.offsetLeft - padding;
          this.track.scrollTo({
            left,
            behavior: behavior || (this.reducedMotion ? 'auto' : 'smooth')
          });
          this.updateActive(normalizedIndex, true);
        }

        onKeydown(event) {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.goTo(this.activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }

        onPointerDown(event) {
          if (!event.isPrimary) return;
          this.pointerState = {
            id: event.pointerId,
            type: event.pointerType,
            x: event.clientX,
            y: event.clientY,
            scrollLeft: this.track.scrollLeft,
            dragging: false,
            vertical: false,
            moved: false
          };
        }

        onPointerMove(event) {
          const state = this.pointerState;
          if (!state || state.id !== event.pointerId) return;
          const deltaX = event.clientX - state.x;
          const deltaY = event.clientY - state.y;
          const absX = Math.abs(deltaX);
          const absY = Math.abs(deltaY);

          if (absX > 8 || absY > 8) state.moved = true;
          if (state.type !== 'mouse' || state.vertical) return;

          if (!state.dragging) {
            if (absY > 6 && absY > absX) {
              state.vertical = true;
              return;
            }
            if (absX <= 8 || absX <= absY) return;
            state.dragging = true;
            this.track.dataset.dragging = 'true';
            this.track.setPointerCapture(event.pointerId);
          }

          event.preventDefault();
          this.track.scrollLeft = state.scrollLeft - deltaX;
        }

        onPointerEnd(event) {
          const state = this.pointerState;
          if (!state || state.id !== event.pointerId) return;
          if (state.moved || state.dragging) this.suppressClickUntil = performance.now() + 350;
          if (state.dragging) this.goTo(this.nearestIndex());
          if (this.track.hasPointerCapture(event.pointerId)) this.track.releasePointerCapture(event.pointerId);
          delete this.track.dataset.dragging;
          this.pointerState = null;
        }

        randomIndex(maximum) {
          if (window.crypto?.getRandomValues) {
            const values = new Uint32Array(1);
            window.crypto.getRandomValues(values);
            return Math.floor((values[0] / 4294967296) * maximum);
          }
          return Math.floor(Math.random() * maximum);
        }

        randomize(items) {
          const randomized = [...items];
          for (let index = randomized.length - 1; index > 0; index -= 1) {
            const swapIndex = this.randomIndex(index + 1);
            [randomized[index], randomized[swapIndex]] = [randomized[swapIndex], randomized[index]];
          }
          return randomized;
        }

        seedInitialBatch() {
          const uniquePool = Array.from(
            new Map(this.poolSlides.map((slide) => [slide.dataset.flashHandle, slide])).values()
          ).filter((slide) => slide.dataset.flashHandle);
          if (uniquePool.length <= this.batchSize) return;

          const initialTemplates = this.randomize(uniquePool).slice(0, this.batchSize);
          this.track.replaceChildren(...initialTemplates.map((slide) => slide.cloneNode(true)));
          this.track.scrollLeft = 0;
          this.dataset.initialSelection = 'random';
        }

        async ensureFullPool() {
          const expectedPages = Math.max(1, Number.parseInt(this.dataset.poolPages || '1', 10));
          if (expectedPages <= 1 || this.dataset.poolReady === 'true') return;
          if (this.poolLoadPromise) return this.poolLoadPromise;

          this.poolLoadPromise = (async () => {
            const knownHandles = new Set(this.poolSlides.map((slide) => slide.dataset.flashHandle));
            for (let page = 2; page <= expectedPages; page += 1) {
              const url = new URL(window.location.href);
              url.hash = '';
              url.searchParams.set('section_id', this.dataset.flashSectionId);
              url.searchParams.set('page', String(page));

              try {
                const response = await fetch(url.toString(), {
                  credentials: 'same-origin',
                  headers: { Accept: 'text/html' }
                });
                if (!response.ok) continue;
                const markup = await response.text();
                const documentFragment = new DOMParser().parseFromString(markup, 'text/html');
                const renderedSections = Array.from(
                  documentFragment.querySelectorAll('urban-flash-preview[data-flash-section-id]')
                );
                const renderedSection = renderedSections.find(
                  (section) => section.dataset.flashSectionId === this.dataset.flashSectionId
                );
                const renderedTemplate = renderedSection?.querySelector('[data-flash-pool]');
                if (!renderedTemplate) continue;

                Array.from(renderedTemplate.content.querySelectorAll('[data-flash-slide]')).forEach((slide) => {
                  const handle = slide.dataset.flashHandle;
                  if (!handle || knownHandles.has(handle)) return;
                  knownHandles.add(handle);
                  this.poolSlides.push(slide.cloneNode(true));
                });
              } catch (_error) {
                // The server-rendered pool remains available if a later page cannot be prefetched.
              }
            }
            this.dataset.poolReady = 'true';
          })();

          return this.poolLoadPromise;
        }

        async shuffle() {
          if (this.shuffleBusy || this.slides.length < 2) return;
          this.shuffleBusy = true;
          this.shuffleButton.setAttribute('aria-disabled', 'true');
          this.shuffleButton.setAttribute('aria-busy', 'true');
          this.dataset.shuffling = 'true';

          await this.ensureFullPool();

          const currentHandles = new Set(this.slides.map((slide) => slide.dataset.flashHandle));
          const uniquePool = Array.from(
            new Map(this.poolSlides.map((slide) => [slide.dataset.flashHandle, slide])).values()
          ).filter((slide) => slide.dataset.flashHandle);
          let candidates = uniquePool.filter((slide) => !currentHandles.has(slide.dataset.flashHandle));
          if (candidates.length < this.batchSize) candidates = uniquePool;

          const selectedTemplates = this.randomize(candidates).slice(0, Math.min(this.batchSize, candidates.length));
          if (!selectedTemplates.length) {
            delete this.dataset.shuffling;
            this.shuffleBusy = false;
            this.shuffleButton.removeAttribute('aria-disabled');
            this.shuffleButton.removeAttribute('aria-busy');
            return;
          }
          const nextBatch = selectedTemplates.map((slide) => slide.cloneNode(true));

          const applyOrder = () => {
            this.track.replaceChildren(...nextBatch);
            this.track.scrollLeft = 0;
            this.refreshSlides();
            this.updateActive(0);
            if (this.liveRegion) {
              const poolTotal = Math.max(this.poolSlides.length, Number.parseInt(this.dataset.poolSize || '0', 10));
              this.liveRegion.textContent = `${this.dataset.shuffleMessage || 'New Flash selection loaded.'} ${nextBatch.length} designs selected from ${poolTotal}.`;
            }

            requestAnimationFrame(() => {
              delete this.dataset.shuffling;
              const release = () => {
                this.shuffleBusy = false;
                this.shuffleButton.removeAttribute('aria-disabled');
                this.shuffleButton.removeAttribute('aria-busy');
              };
              if (this.reducedMotion) release();
              else window.setTimeout(release, 160);
            });
          };

          if (this.reducedMotion) applyOrder();
          else window.setTimeout(applyOrder, 90);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["urban-home-selected-work-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = "[data-selected-work-v2]";

    const init = (root) => {
      if (!root || root.dataset.workReady === "true") return;

      const track = root.querySelector("[data-work-track]");
      const live = root.querySelector("[data-work-live]");
      if (!track) return;

      const slides = Array.from(track.querySelectorAll("[data-work-slide]"));
      if (!slides.length) return;

      root.dataset.workReady = "true";
      const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      let currentIndex = 0;
      let scrollFrame = 0;
      let announceTimer = 0;
      let suppressClickUntil = 0;
      let pointerState = null;
      let touchState = null;

      const slideLeft = (slide) => slide.offsetLeft;

      const nearestIndex = () => {
        const trackCenter = track.scrollLeft + track.clientWidth / 2;
        let nearest = 0;
        let nearestDistance = Number.POSITIVE_INFINITY;

        slides.forEach((slide, index) => {
          const center = slideLeft(slide) + slide.offsetWidth / 2;
          const distance = Math.abs(center - trackCenter);
          if (distance < nearestDistance) {
            nearest = index;
            nearestDistance = distance;
          }
        });

        return nearest;
      };

      const setCurrent = (index, announce = false) => {
        const safeIndex = (index + slides.length) % slides.length;
        if (safeIndex === currentIndex && !announce) return;
        currentIndex = safeIndex;

        slides.forEach((slide, slideIndex) => {
          if (slideIndex === currentIndex) slide.setAttribute("aria-current", "true");
          else slide.removeAttribute("aria-current");
        });

        if (announce && live) {
          window.clearTimeout(announceTimer);
          announceTimer = window.setTimeout(() => {
            live.textContent = slides[currentIndex].dataset.announcement || "";
          }, 160);
        }
      };

      const goTo = (index, announce = true) => {
        const safeIndex = (index + slides.length) % slides.length;
        const behavior = reducedMotion.matches ? "auto" : "smooth";
        track.scrollTo({ left: slideLeft(slides[safeIndex]), behavior });
        setCurrent(safeIndex, announce);
      };

      track.addEventListener("scroll", () => {
        if (scrollFrame) return;
        scrollFrame = window.requestAnimationFrame(() => {
          scrollFrame = 0;
          setCurrent(nearestIndex(), true);
        });
      }, { passive: true });

      root.addEventListener("click", (event) => {
        const nextButton = event.target.closest("[data-work-next]");
        if (!nextButton || !root.contains(nextButton)) return;
        const slide = nextButton.closest("[data-work-slide]");
        const index = slides.indexOf(slide);
        goTo(index + 1);
      });

      track.addEventListener("keydown", (event) => {
        if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") return;
        event.preventDefault();
        goTo(currentIndex + (event.key === "ArrowRight" ? 1 : -1));
      });

      track.addEventListener("pointerdown", (event) => {
        if (event.pointerType !== "mouse" || event.button !== 0) return;
        if (event.target.closest("button")) return;
        pointerState = {
          id: event.pointerId,
          x: event.clientX,
          y: event.clientY,
          startScroll: track.scrollLeft,
          dragging: false,
          vertical: false,
        };
      });

      track.addEventListener("pointermove", (event) => {
        if (!pointerState || pointerState.id !== event.pointerId || pointerState.vertical) return;

        const deltaX = event.clientX - pointerState.x;
        const deltaY = event.clientY - pointerState.y;

        if (!pointerState.dragging) {
          if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 7) return;
          if (Math.abs(deltaY) >= Math.abs(deltaX)) {
            pointerState.vertical = true;
            return;
          }
          pointerState.dragging = true;
          track.classList.add("is-dragging");
          track.setPointerCapture(event.pointerId);
        }

        event.preventDefault();
        track.scrollLeft = pointerState.startScroll - deltaX;
      });

      const finishPointer = (event) => {
        if (!pointerState || pointerState.id !== event.pointerId) return;
        const wasDragging = pointerState.dragging;
        pointerState = null;

        if (!wasDragging) return;
        suppressClickUntil = Date.now() + 450;
        track.classList.remove("is-dragging");
        if (track.hasPointerCapture(event.pointerId)) track.releasePointerCapture(event.pointerId);
        goTo(nearestIndex());
      };

      track.addEventListener("pointerup", finishPointer);
      track.addEventListener("pointercancel", finishPointer);

      track.addEventListener("touchstart", (event) => {
        if (event.touches.length !== 1 || event.target.closest("button")) {
          touchState = null;
          return;
        }

        touchState = {
          x: event.touches[0].clientX,
          y: event.touches[0].clientY,
          horizontal: false,
        };
      }, { passive: true });

      track.addEventListener("touchmove", (event) => {
        if (!touchState || event.touches.length !== 1) return;
        const deltaX = event.touches[0].clientX - touchState.x;
        const deltaY = event.touches[0].clientY - touchState.y;
        if (Math.max(Math.abs(deltaX), Math.abs(deltaY)) < 7) return;
        touchState.horizontal = Math.abs(deltaX) > Math.abs(deltaY);
      }, { passive: true });

      const finishTouch = () => {
        if (touchState?.horizontal) suppressClickUntil = Date.now() + 450;
        touchState = null;
      };

      track.addEventListener("touchend", finishTouch, { passive: true });
      track.addEventListener("touchcancel", finishTouch, { passive: true });

      track.addEventListener("click", (event) => {
        if (!event.target.closest("[data-work-link]")) return;
        if (Date.now() >= suppressClickUntil) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      }, true);

      setCurrent(0);
    };

    const initAll = (scope = document) => {
      if (scope.matches?.(selector)) init(scope);
      scope.querySelectorAll?.(selector).forEach(init);
    };

    initAll();
    document.addEventListener("shopify:section:load", (event) => initAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
